<template>
  <a-select
    :disabled="disabled"
    :multiple="false"
    :placeholder="placeholder"
    :value="value"
    allow-clear
    option-filter-prop="title"
    show-search
    @change="onChange"
  >
    <a-select-option v-for="item in records" :key="item.id" :title="item.name" :value="item.id">{{
      item.name
    }}</a-select-option>
  </a-select>
</template>

<script lang="ts">
import { GuaranteeAgreementService } from "@/views/maintenance/guarantee-agreement/guarantee-agreement.service";
import { defineComponent, watch } from "vue";
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
/**
 * 工单类型
 *
 * 使用方式:
 * <guarantee-agreement-select v-model:value="formRef.id"></guarantee-agreement-select>
 */
export default defineComponent({
  isGlobal: true,
  props: {
    value: {
      type: String,
      default: undefined,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    placeholder: {
      type: String,
      default: "请选择",
    },
    api: {
      type: String,
    },
    defaultValue: {
      type: String,
      default: undefined,
    },
    maintenanceProjectId: {
      type: String,
      default: undefined,
    },
    status: {
      type: String,
      default: undefined,
    },
    flowStatus: {
      type: String,
      default: undefined,
    },
    type: {
      type: String,
      default: undefined,
    },
  },
  emits: ["update:value", "change"],
  setup(props, { emit }) {
    const { data: records, run, loading } = GuaranteeAgreementService.useSimpleListApi();
    const onChange = async (id) => {
      emit("update:value", id);
      let item = (records.value || []).find((r) => r.id == id);
      emit("change", item);
    };

    watch(
      () => props.maintenanceProjectId, //选择项目改变时
      async (n) => {
        // console.log("🚀 ~ file: index.vue:74 ~ n:", n);

        if (n) {
          await run({
            projectId: n,
            status: props.status,
            flowStatus: props.flowStatus,
            type: props.type,
          });
          let item = (records.value || []).find((r) => r.id == props.value);
          if (!item) {
            emit("update:value", null);
            emit("change", null);
          }
        } else {
          let item = (records.value || []).find((r) => r.id == props.value);
          if (!item && records.value?.length > 0) {
            emit("update:value", null);
            emit("change", null);
          }
        }

        // selectedKeys.value = props.value ? [props.value] : [];
      },
      { immediate: true }
    );
    onMountedOrActivated(async () => {
      await run({ type: props.type, projectId: props.maintenanceProjectId,
            status: props.status,
            flowStatus: props.flowStatus,
            });
      // console.log("🚀 ~ file: index.vue:65 ~ onMounted ~ records:", records);
      // if (props.defaultValue) {
      //   let item = ((records.value || []) as Array<any>).find((r) => r.name == props.defaultValue);
      //   if (item) {
      //     emit("update:value", item.id);
      //     emit("change", item.id);
      //   }
      // }
    });

    return {
      records,
      loading,
      onChange,
    };
  },
});
</script>
